// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13yic","top":"styles_top__3lYX_"};